import styled from 'styled-components';

import { FlexCenter, Text } from 'src/client/components';

import { BUTTON_2_2 } from 'src/client/constants/text';

import DragAndDropArea from '../DragAndDropArea';

export const StyledDragAndDropArea = styled(DragAndDropArea)`
  padding: 0 24px 24px;

  .drag-and-drop-area {
    display: block;
    padding-top: 16px;
    margin-bottom: 0;
  }
`;

export const FeaturedCardsContainer = styled(FlexCenter)`
  flex-wrap: wrap;
  gap: 16px;
`;

export const SpotlightSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 48px;
`;

export const SpotlightText = styled(Text)`
  text-align: center;
  margin-bottom: 18px;
  max-width: 527px;
`;

export const TogetherViewSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-top: 48px;
  margin-bottom: 18px;

  & button span {
    ${BUTTON_2_2}
  }
`;
